module.exports = "/_next/static/images/a3d33c9e0730d8b9c37c2546c23da5f6-card-lg.png";